import React, { useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
  TextField,
  Divider
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const CartModal = ({ open, onClose, cart, setCart, onCheckout }) => {
  const [discountCode, setDiscountCode] = useState('');
  const [discountApplied, setDiscountApplied] = useState(false);
  const [discountError, setDiscountError] = useState('');

  const calculateTotal = () => {
    return cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  };

  const calculateDiscountedTotal = () => {
    return discountApplied ? calculateTotal() * 0.9 : calculateTotal();
  };

  const applyDiscount = () => {
    if (discountCode === 'REBEL10') {
      setDiscountApplied(true);
      setDiscountError('');
    } else {
      setDiscountError('Código inválido');
    }
  };

  const changeQuantity = (productId, amount) => {
    setCart(
      cart.map((item) =>
        item.id === productId
          ? { ...item, quantity: Math.max(1, item.quantity + amount) }
          : item
      )
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: 'rgba(20,20,20,0.9)',
          backdropFilter: 'blur(10px)',
          border: '2px solid #ff6e00',
          borderRadius: '16px',
          boxShadow: '0 0 30px rgba(255,110,0,0.4)',
          color: '#fff',
          minWidth: { xs: '90%', sm: '500px' }
        }
      }}
    >
      {/* TITLE */}
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.8rem' }}>
        🛒 Carrito Rebel Fox
      </DialogTitle>

      <DialogContent>
        {cart.length === 0 ? (
          <Typography sx={{ textAlign: 'center', opacity: 0.7 }}>
            Tu carrito está vacío
          </Typography>
        ) : (
          <>
            {/* ITEMS */}
            {cart.map((item) => (
              <Box
                key={item.id}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                  p: 1.5,
                  borderRadius: '10px',
                  background: 'rgba(255,255,255,0.03)'
                }}
              >
                <Box>
                  <Typography sx={{ fontWeight: 'bold' }}>{item.name}</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.7 }}>
                    ${item.price} x {item.quantity}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Button
                    size="small"
                    onClick={() => changeQuantity(item.id, -1)}
                    disabled={item.quantity === 1}
                    sx={{ minWidth: '32px', color: '#ffae00' }}
                  >
                    -
                  </Button>

                  <Typography>{item.quantity}</Typography>

                  <Button
                    size="small"
                    onClick={() => changeQuantity(item.id, 1)}
                    sx={{ minWidth: '32px', color: '#ffae00' }}
                  >
                    +
                  </Button>

                  <IconButton
                    color="error"
                    onClick={() =>
                      setCart(cart.filter((i) => i.id !== item.id))
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Box>
            ))}

            <Divider sx={{ my: 2, background: 'rgba(255,255,255,0.1)' }} />

            {/* DISCOUNT */}
            <TextField
              label="Código de descuento"
              value={discountCode}
              onChange={(e) => setDiscountCode(e.target.value)}
              fullWidth
              margin="normal"
              helperText={
                discountError ||
                (discountApplied && '✔ Descuento del 10% aplicado')
              }
              error={!!discountError}
              disabled={discountApplied}
              sx={{
                input: { color: '#fff' },
                label: { color: '#aaa' },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: '#ff6e00' },
                  '&:hover fieldset': { borderColor: '#ffae00' }
                }
              }}
            />

            <Button
              onClick={applyDiscount}
              disabled={discountApplied}
              fullWidth
              sx={{
                mt: 1,
                color: '#ffae00',
                border: '1px solid #ff6e00',
                '&:hover': {
                  background: 'rgba(255,110,0,0.1)'
                }
              }}
            >
              {discountApplied ? 'Descuento Aplicado' : 'Aplicar descuento'}
            </Button>

            {/* TOTAL */}
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              {discountApplied && (
                <Typography
                  sx={{
                    textDecoration: 'line-through',
                    opacity: 0.6
                  }}
                >
                  ${calculateTotal().toFixed(2)}
                </Typography>
              )}

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 'bold',
                  color: discountApplied ? '#00e676' : '#fff'
                }}
              >
                ${calculateDiscountedTotal().toFixed(2)}
              </Typography>
            </Box>

            {/* CHECKOUT */}
            <Button
              variant="contained"
              fullWidth
              onClick={onCheckout}
              disabled={cart.length === 0}
              sx={{
                mt: 3,
                py: 1.5,
                fontWeight: 'bold',
                fontSize: '1rem',
                background: 'linear-gradient(90deg, #ff6e00, #ffae00)',
                boxShadow: '0 0 15px rgba(255,110,0,0.6)',
                '&:hover': {
                  boxShadow: '0 0 25px rgba(255,110,0,1)'
                }
              }}
            >
              Finalizar compra
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CartModal;